import { render } from "./XToYDashboardComponent.vue?vue&type=template&id=3ed64004&scoped=true&ts=true"
import script from "./XToYDashboardComponent.vue?vue&type=script&lang=ts"
export * from "./XToYDashboardComponent.vue?vue&type=script&lang=ts"

import "./XToYDashboardComponent.vue?vue&type=style&index=0&id=3ed64004&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed64004"]])

export default __exports__